const home = {
  // Hero
  'hero.brand': 'NOREN',
  'hero.brandSub': '日本の不動産',
  'hero.title': 'Own a home in Japan',
  'hero.titleItalic': '— without the maze.',
  'hero.subtitle': 'We find, inspect, purchase, renovate, and operate Japanese properties for buyers overseas. End to end. In English. You never have to fly here.',
  'hero.pricePoint': 'From $3,300 entry point (≈ ¥500,000). Cash only.',
  'hero.ctaPrimary': 'Browse homes',
  'hero.ctaSecondary': 'See what we do',

  // Trust bar
  'trust.entry': '$3,300+',
  'trust.entrySub': 'entry point',
  'trust.entryDetail': 'Cash purchase',
  'trust.fx': '30–40%',
  'trust.fxSub': 'effective FX discount',
  'trust.fxDetail': 'For USD/EUR/GBP buyers since 2021',
  'trust.yield': '8–12%',
  'trust.yieldSub': 'targeted net yields',
  'trust.yieldDetail': 'Conservative modelling, not a promise',
  'trust.remote': '100%',
  'trust.remoteSub': 'remote',
  'trust.remoteDetail': 'You never fly to Japan',

  // Services
  'services.sectionLabel': 'What we do',
  'services.title': 'Four services.',
  'services.titleItalic': 'Each optional.',
  'services.titleLine3': 'Each builds on the last.',
  'services.intro': 'Start with purchase support. Add renovation, rental launch, or full management as you need them. No bundles, no lock-in.',
  'services.showLess': 'Show less',
  'services.whatsIncluded': 'What is included',
  'services.step1': '01',
  'services.step1Title': 'Purchase only',
  'services.step1Price': 'From ¥480,000 support fee',
  'services.step1Desc': 'We source homes for sale, inspect in person, negotiate, and handle the entire closing process. You get a bilingual purchase contract, a structural report, and a clear renovation estimate before you transfer a yen.',
  'services.step1Inc1': 'Direct property sourcing',
  'services.step1Inc2': 'In-person structural inspection',
  'services.step1Inc3': 'Bilingual contract review',
  'services.step1Inc4': 'Closing coordination',
  'services.step1Inc5': 'Renovation pre-estimate',
  'services.step2': '02',
  'services.step2Title': 'Turnkey renovation',
  'services.step2Price': 'Reno cost + 20% project-management margin',
  'services.step2Desc': 'We design, permit, and manage the full renovation using our in-house team and vetted local contractors. Delivered livable or rentable — your choice. Weekly photo updates, cost tracking, and zero surprises.',
  'services.step2Inc1': 'Full design and permitting',
  'services.step2Inc2': 'Contractor management',
  'services.step2Inc3': 'Material procurement',
  'services.step2Inc4': 'Weekly progress reports',
  'services.step2Inc5': 'Final inspection and handover',
  'services.step3': '03',
  'services.step3Title': 'Launch as a rental',
  'services.step3Price': 'From ¥600,000 setup',
  'services.step3Desc': 'We handle licensing (minpaku or ryokan-gyo), fire compliance, furnishing, professional photography, OTA listings, and local pricing strategy. Your property goes live with bookings from day one.',
  'services.step3Inc1': 'Minpaku or ryokan-gyo licensing',
  'services.step3Inc2': 'Fire safety compliance',
  'services.step3Inc3': 'Interior furnishing and staging',
  'services.step3Inc4': 'Professional photography',
  'services.step3Inc5': 'OTA listing and pricing setup',
  'services.step4': '04',
  'services.step4Title': 'We run it for you',
  'services.step4Price': '20% of STR revenue, or 5% of long-term rent',
  'services.step4Desc': 'Full ongoing management: guest communication, cleaning coordination, maintenance, repairs, bi-monthly statutory reporting, and annual tax representation. You receive a P&L every month in English.',
  'services.step4Inc1': 'Guest communication (EN/JP)',
  'services.step4Inc2': 'Cleaning and linen coordination',
  'services.step4Inc3': 'Maintenance and repairs',
  'services.step4Inc4': 'Bi-monthly statutory reporting',
  'services.step4Inc5': 'Annual tax representation',
  'services.step4Inc6': 'Monthly P&L in English',

  // Listings
  'listings.sectionLabel': 'Homes for sale',
  'listings.title': 'Browse homes',
  'listings.titleItalic': 'for every budget.',
  'listings.intro': 'Japanese homes available now, from $3,300 (≈ ¥500,000). New listings added weekly.',
  'listings.sampleNote': 'These are representative examples. The actual list changes weekly.',

  // Co-ownership promo (home)
  'coPromo.sectionLabel': 'Co-ownership matching',
  'coPromo.title': 'Split the cost.',
  'coPromo.titleItalic': 'Keep your name on title.',
  'coPromo.body': 'NOREN introduces verified co-owners for properties suited to shared purchase. Each owner buys their share directly on title in their own name. We do not pool money, run investments, or guarantee returns.',
  'coPromo.example': 'Example',
  'coPromo.exampleTitle': 'Odawara machiya guesthouse',
  'coPromo.exampleAllIn': 'all-in',
  'coPromo.exampleProgress': '2 of 4 co-owners joined',
  'coPromo.exampleSpots': '2 spots left',

  // Process
  'process.sectionLabel': 'The Process',
  'process.title': 'Four steps.',
  'process.titleItalic': 'You never fly here.',
  'process.intro': 'From first conversation to a rented, operating property. Each step is managed in English. Each document is translated.',
  'process.step1': '01',
  'process.step1Title': 'Tell us your budget and goals',
  'process.step1Desc': 'We learn what you want — live-in, renovation project, or rental income. We also learn what you do not want. That honesty cuts the search time in half.',
  'process.step2': '02',
  'process.step2Title': 'We shortlist & inspect in person',
  'process.step2Desc': 'Our team visits every property. We film the walkthrough, flag structural issues, check utilities, and price the renovation. You get a shortlist with real numbers — no glossy brochures.',
  'process.step3': '03',
  'process.step3Title': 'We buy & renovate remotely',
  'process.step3Desc': 'Contract, notary, bank transfer, registration — all handled in English. Renovation managed by our in-house team. All 2026 filing and disclosure requirements (FEFTA, tax, municipal) are handled for you.',
  'process.step4': '04',
  'process.step4Title': 'Live in it or earn from it',
  'process.step4Desc': 'Move in, visit seasonally, or launch as a rental. We operate it if you want us to. You receive monthly P&L reports in English. Distance stops mattering.',

  // Renovation stories
  'reno.sectionLabel': '/ Renovation Stories',
  'reno.title': 'Before & after.',
  'reno.titleItalic': 'What our team delivers.',
  'reno.intro': 'Every property we renovate is documented. These are representative examples — each project has its own scope, timeline, and budget.',
  'reno.beforeLabel': 'Before',
  'reno.beforeDesc': 'Abandoned akiya in Shikoku. Structural frame intact. Full gut required: new electrics, plumbing, insulation, and interior finishes.',
  'reno.afterLabel': 'After',
  'reno.afterDesc': 'Same property, six months later. Turnkey guesthouse with ryokan-gyo licence, furnished, photographed, and listed. Now operating.',

  // Returns
  'returns.sectionLabel': '/ Illustrative Returns',
  'returns.title': 'One honest, conservative',
  'returns.titleItalic': 'worked example.',
  'returns.intro': 'Not a promise. Not a projection. A real property we modelled before purchase. Every property in our inventory is run through this same math.',
  'returns.badge': 'Rural kominka + ryokan-gyo licence',
  'returns.badgeSub': '365-day rental',
  'returns.purchase': 'Purchase price',
  'returns.renovation': 'Renovation (full gut + systems)',
  'returns.licence': 'Ryokan-gyo licence + fire compliance',
  'returns.furnish': 'Furnishing + photography + OTA setup',
  'returns.allIn': 'All-in investment',
  'returns.gross': 'Gross annual revenue',
  'returns.grossNote': '¥6,575 avg / night, 55% occupancy',
  'returns.costs': 'Annual operating costs',
  'returns.costsNote': 'Cleaning, maintenance, management, tax',
  'returns.noi': 'Net Operating Income (NOI)',
  'returns.yieldLabel': 'Net yield on all-in cost',
  'returns.important': 'Important:',
  'returns.importantText': 'This is a single illustrative example, not a promise or projection. Every property is modelled individually before purchase. Actual yields depend on location, property condition, renovation scope, licensing path, and market demand. We share the full model with every shortlisted property.',

  // Honest FAQ
  'faq.sectionLabel': '/ Radical Honesty',
  'faq.title': 'Hard truths.',
  'faq.titleItalic': 'Answered plainly.',
  'faq.intro': 'The questions every overseas buyer should ask before transferring a yen. We answer them upfront so you do not discover them halfway through.',
  'faq.q1': 'Can I get a mortgage as a non-resident?',
  'faq.a1': 'No. Japanese banks do not lend to foreign non-residents without a local guarantor and documented Japan-sourced income. If you are not living and working in Japan, plan on cash only. We have never seen an overseas buyer secure a mortgage. Do not build your strategy around it.',
  'faq.q2': 'Does buying property give me a visa?',
  'faq.a2': 'No. There is no "golden visa" or investor residency attached to real estate ownership in Japan. Owning a house does not entitle you to live here. You will still need a standard visa for stays longer than 90 days. We mention this because some buyers assume otherwise — and we would rather tell you now than after purchase.',
  'faq.q3': 'How many days can I rent on Airbnb?',
  'faq.a3': 'Under the Minpaku Law, unlicensed short-term rental is capped at 180 nights per year. For unlimited rental income, you need a ryokan-gyo licence, which requires specific zoning, fire-code compliance, and a local manager on call 24 hours. We file the paperwork. We do not pretend the cap does not exist.',
  'faq.q4': 'Why is that house only ¥500,000?',
  'faq.a4': 'Because it is abandoned, often structurally compromised, in a shrinking town with thin rental demand, and needs a full gut renovation that may cost 3–5× the purchase price. Sometimes the right answer is "do not buy this one." We model occupancy, renovation cost, and realistic rental income before you commit. No cherry-picked examples.',

  // CTA / Inquiry
  'cta.sectionLabel': 'Get in touch',
  'cta.title': 'Find your home in Japan',
  'cta.titleItalic': 'for your budget.',
  'cta.intro': 'Tell us your budget, goals, and timeline. We will send you a curated shortlist of homes for sale — with real numbers, real photos, and honest assessments.',
  'cta.firstName': 'First name',
  'cta.lastName': 'Last name',
  'cta.email': 'Email',
  'cta.country': 'Country',
  'cta.budget': 'Budget range (JPY)',
  'cta.goal': 'Intended use',
  'cta.message': 'Message (optional)',
  'cta.messagePlaceholder': 'Tell us your timeline, preferred regions, or any questions...',
  'cta.privacy': 'We never share your details. Typical response time: under 48 hours.',
};

export default home;